import { ApplicationConfig } from '@angular/core';

import {
  DATE_PIPE_DEFAULT_TIMEZONE
} from '@angular/common';

import {
  provideHttpClient,
  withInterceptors
} from '@angular/common/http';

import { provideRouter } from '@angular/router';

import { routes } from './app.routes';

import { authInterceptor }
  from './core/interceptors/auth.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    {
      provide: DATE_PIPE_DEFAULT_TIMEZONE,
      useValue: 'Europe/Rome'
    },

    provideRouter(routes),

    provideHttpClient(
      withInterceptors([authInterceptor])
    )
  ]
};